import { render, staticRenderFns } from "./parts_edit_head.vue?vue&type=template&id=d6e6e1ee&scoped=true&"
import script from "./parts_edit_head.vue?vue&type=script&lang=js&"
export * from "./parts_edit_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e6e1ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6e6e1ee')) {
      api.createRecord('d6e6e1ee', component.options)
    } else {
      api.reload('d6e6e1ee', component.options)
    }
    module.hot.accept("./parts_edit_head.vue?vue&type=template&id=d6e6e1ee&scoped=true&", function () {
      api.rerender('d6e6e1ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/parts_reserv/editor/parts_edit_head.vue"
export default component.exports